import { useState } from "react";
import { Plus, X } from "lucide-react";
import { eur, slotLabel } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

const Row = ({ checked, onToggle, title, sub, extra, testid, children }) => (
  <div className={`rounded-xl border p-3 transition-colors ${checked ? "border-[#0D3B52] bg-[#0D3B52]/[0.03]" : "border-[#E2DDD5] bg-white"}`}>
    <label className="flex items-start gap-3 cursor-pointer">
      <Checkbox checked={checked} onCheckedChange={onToggle} data-testid={testid} className="mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-sm text-[#0D3B52]">{title}</p>
        <p className="text-xs text-[#5C6B73]">{sub}</p>
        {extra}
      </div>
    </label>
    {children}
  </div>
);

export const RiconsegneList = ({ items, sel, setSel, onUnflag }) => {
  if (!items.length) return <p className="text-sm text-[#5C6B73]">Nessuna riconsegna in sospeso. Segnale dalla sezione Cremazioni.</p>;
  const upd = (id, patch) => setSel((p) => ({ ...p, [id]: { ...p[id], ...patch } }));
  return (
    <div className="space-y-2" data-testid="riconsegne-pending-list">
      {items.map((p) => {
        const s = sel[p.id];
        return (
          <Row key={p.id} checked={!!s} testid={`riconsegna-select-${p.id}`}
            onToggle={(v) => setSel((prev) => { const n = { ...prev }; if (v) n[p.id] = { from: "", to: "" }; else delete n[p.id]; return n; })}
            title={`${p.nome} – ${p.animale_nome || p.specie || "animale"}`}
            sub={`${p.indirizzo || "indirizzo mancante"} ${p.citta || ""}`}
            extra={p.residuo > 0 && <p className="text-xs font-semibold text-rose-700 mt-0.5">Da incassare {eur(p.residuo)}</p>}>
            <div className="flex items-center gap-2 mt-2 pl-7">
              {s && (
                <>
                  <span className="text-xs text-[#5C6B73]">Orario preferito</span>
                  <Input type="time" value={s.from} onChange={(e) => upd(p.id, { from: e.target.value })} className="h-8 w-[110px] bg-white text-xs" data-testid={`riconsegna-from-${p.id}`} />
                  <Input type="time" value={s.to} onChange={(e) => upd(p.id, { to: e.target.value })} className="h-8 w-[110px] bg-white text-xs" data-testid={`riconsegna-to-${p.id}`} />
                </>
              )}
              <button type="button" onClick={() => onUnflag(p)} className="ml-auto text-xs text-[#5C6B73] hover:text-rose-700" data-testid={`riconsegna-unflag-${p.id}`}>Rimuovi</button>
            </div>
          </Row>
        );
      })}
    </div>
  );
};

export const RitiriList = ({ items, sel, setSel }) => {
  if (!items.length) return <p className="text-sm text-[#5C6B73]">Nessun ritiro prenotato in questa data.</p>;
  return (
    <div className="space-y-2" data-testid="ritiri-day-list">
      {items.map((b) => (
        <Row key={b.id} checked={!!sel[b.id]} testid={`ritiro-select-${b.id}`}
          onToggle={(v) => setSel((p) => ({ ...p, [b.id]: !!v }))}
          title={`${slotLabel(b.slot_start)} · ${b.vet_name || b.owner_name || "Ritiro"}`}
          sub={`${b.pet_name || b.species || ""} · ${b.pickup_address} ${b.city || ""}`} />
      ))}
    </div>
  );
};

export const ExtraStops = ({ items, setItems }) => {
  const [f, setF] = useState({ label: "", address: "" });
  const add = () => {
    if (!f.address.trim()) return;
    setItems((p) => [...p, { ...f, id: Date.now() }]);
    setF({ label: "", address: "" });
  };
  return (
    <div className="space-y-2">
      {items.map((x) => (
        <div key={x.id} className="flex items-center gap-2 rounded-xl border border-[#E2DDD5] bg-white p-3 text-sm">
          <div className="flex-1 min-w-0"><p className="font-semibold text-[#0D3B52]">{x.label || "Tappa extra"}</p><p className="text-xs text-[#5C6B73] truncate">{x.address}</p></div>
          <button type="button" onClick={() => setItems((p) => p.filter((y) => y.id !== x.id))} className="text-[#5C6B73] hover:text-rose-700"><X className="h-4 w-4" /></button>
        </div>
      ))}
      <div className="grid sm:grid-cols-[1fr_1.4fr_auto] gap-2">
        <Input placeholder="Descrizione" value={f.label} onChange={(e) => setF({ ...f, label: e.target.value })} className="bg-white" data-testid="extra-stop-label" />
        <Input placeholder="Via, numero, città" value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} className="bg-white" data-testid="extra-stop-address" />
        <Button type="button" variant="outline" onClick={add} data-testid="extra-stop-add" className="rounded-full"><Plus className="h-4 w-4" /></Button>
      </div>
    </div>
  );
};
